import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { ListField, identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
function ListFieldLiteralInternal(props) {
    return _jsx(ListField, { ...props, literal: true });
}
ListFieldLiteralInternal.displayName = "DployListFieldLiteral";
export const ListFieldLiteral = memo(ListFieldLiteralInternal);
const literalListFieldEditorProps = {
    suffix: true
};
export const EditorListFieldLiterals = identityRecordOfFieldEditorOptions({
    ListFieldLiteral: {
        editableOptions: literalListFieldEditorProps
    }
});
//# sourceMappingURL=ListFieldLiteral.js.map